import React from 'react';
import type { SelectedGrades, DiscountRates, Totals } from '../services/estimateCalculation';
import lxhausysLogoWhite from '../image/lxhausys.png';
import homewindowLogoWhite from '../image/homewindow.png';
import kccLogoWhite from '../image/kcchomeCC.png';

interface CheckboxState {
  homeWindow: boolean;
  lxHausys: boolean;
  kccHomeCC: boolean;
}

interface PricingSummaryCardsProps {
  checkboxes: CheckboxState;
  setCheckboxes: React.Dispatch<React.SetStateAction<CheckboxState>>;
  selectedGrades: SelectedGrades;
  discountRates: DiscountRates;
  totals: Totals;
  formatNumber: (n: number) => string;
}

const BRANDS = [
  { key: 'lxHausys' as const, label: 'LX하우시스', color: '#b72c2c', headerColor: '#b72c2c', logo: lxhausysLogoWhite },
  { key: 'homeWindow' as const, label: '홈윈도우', color: '#333', headerColor: '#333', logo: homewindowLogoWhite },
  { key: 'kccHomeCC' as const, label: 'KCC홈씨씨', color: '#0056b8', headerColor: '#0056b8', logo: kccLogoWhite },
];

const DISCOUNT_RATE_KEY: Record<string, keyof DiscountRates> = {
  homeWindow: 'homeWindow',
  lxHausys: 'LX하우시스',
  kccHomeCC: 'KCC홈CC',
};

const PricingSummaryCards: React.FC<PricingSummaryCardsProps> = ({
  checkboxes, setCheckboxes, selectedGrades, discountRates, totals, formatNumber,
}) => {
  return (
    <>
      <div className="section-title section-title-main">견적합계</div>
      <div className="estimate-summary-cards">
        {BRANDS.map((brand) => (
          <div
            key={brand.key}
            className={`summary-card ${
              checkboxes[brand.key]
                ? 'summary-card-active'
                : 'summary-card-inactive'
            }`}
            onClick={() =>
              setCheckboxes((prev) => ({
                ...prev,
                [brand.key]: !prev[brand.key],
              }))
            }
            style={{
              border: `3px solid ${brand.headerColor}`,
              borderRadius: '8px'
            }}>
            {/* 상단 헤더 */}
            <div
              className="summary-card-header"
              style={{ background: brand.headerColor }}>
              <img
                src={brand.logo}
                alt={brand.label}
                className={`summary-card-logo ${
                  brand.key === 'homeWindow'
                    ? 'summary-card-logo-homeWindow'
                    : 'summary-card-logo-other'
                }`}
              />
            </div>
            <div className="summary-card-body">
              {/* 선택된 등급 표시 */}
              <div className="selected-grade-display">
                {brand.key === 'lxHausys' && (
                  <span>{selectedGrades.LX === '프리미엄' ? 'PREMIUM' : selectedGrades.LX === '스탠다드' ? 'STANDARD' : 'BASIC'} 등급</span>
                )}
                {brand.key === 'homeWindow' && (
                  <span>{selectedGrades.홈윈도우 === '프리미엄' ? 'PREMIUM' : selectedGrades.홈윈도우 === '스탠다드' ? 'STANDARD' : 'BASIC'} 등급</span>
                )}
                {brand.key === 'kccHomeCC' && (
                  <span>ONE 등급</span>
                )}
              </div>
              {/* 할인율/정상가 */}
              <div className="discount-badge">
                {Number(discountRates[DISCOUNT_RATE_KEY[brand.key]]) > 0
                  ? `샤시 ${discountRates[DISCOUNT_RATE_KEY[brand.key]]}% 할인 적용`
                  : '정상가'}
              </div>
              {/* 공급가 */}
              <div className="price-row">
                <span className="price-label">공급가</span>
                <span className="price-value">
                  {formatNumber(Math.round(totals[brand.key]?.sum || 0))} 원
                </span>
              </div>
              {/* 부가세 */}
              <div className="price-row">
                <span className="price-label">부가세</span>
                <span className="price-value-gray">
                  {formatNumber(
                    Math.round(
                      (totals[brand.key]?.vat || 0) -
                        (totals[brand.key]?.sum || 0)
                    )
                  )}{' '}
                  원
                </span>
              </div>
              {/* 구분선 */}
              <hr className="divider" />
              {/* 최종 견적가 */}
              <div className="price-row-total">
                <span className="total-label">최종 견적가</span>
                <span className="price-value-large">
                  {formatNumber(Math.round(totals[brand.key]?.final || 0))} 원
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PricingSummaryCards;
